module.exports = __webpack_public_path__ + "static/media/jaune.12674cee.png";